import React from 'react'
import { Tabs } from 'antd'
import { getDataOfType } from 'src/lib/utils/get-data-of-type'

function getPropsChild({ props }) {
  const { name, schema } = props
  return getDataOfType(schema, ['properties', name], Object, {})
}

function TableTabs({ children }) {
  if (Boolean(children?.length) === false) {
    return null
  }

  const items = React.Children.toArray(children).map((child: any, index) => {
    const { title, description } = getPropsChild(child)
    return {
      key: String(index),
      label: title,
      children: (
        <>
          <p>{description}</p>
          {child}
        </>
      ),
    }
  })

  return <Tabs type="card" size="small" items={items} />
}

export default TableTabs
